import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Professionell",
  icon: "💼",
  templates: [
    {
      title: "YouTube- / Video-Skript",
      content: `Schreiben Sie ein Skript für ein YouTube-Video, das von einer einzelnen Person erzählt wird.
- Das Videothema ist [5 häufige Fehler im Homeoffice — und wie man sie behebt].
- Zielgruppe: [junge Berufstätige, die ihren ersten Remote-Job beginnen].
- Ton: [freundlich, gesprächig und praktisch — wie Ratschläge von einem vertrauenswürdigen Kollegen].
- Strukturieren Sie mit einem starken Aufhänger in den ersten zwei Sätzen, klaren Übergängen zwischen den Punkten und einem kurzen Schluss mit Handlungsaufforderung.
- Schreiben Sie für gesprochene Sprache: Verwenden Sie kurze Absätze und rhetorische Fragen, um die Aufmerksamkeit der Zuhörer zu halten.`
    },
    {
      title: "Produkterklärung",
      content: `Schreiben Sie ein Voiceover-Skript für ein Produkterklärvideo.
- Das Produkt ist [eine mobile App, die Kleinunternehmern hilft, Ausgaben durch das Scannen von Belegen zu verfolgen].
- Zielgruppe: [Freiberufler und Kleinunternehmer, die Buchhaltung hassen].
- Wichtige Vorteile, die hervorgehoben werden sollen:
  1. [Beleg in 2 Sekunden scannen — keine manuelle Eingabe].
  2. [Automatische Ausgabenkategorien mit intelligenten Vorschlägen].
  3. [Ein-Tipp-Export für die Steuersaison].
- Ton: [klar, optimistisch und beruhigend — das macht eine lästige Aufgabe einfach].
- Halten Sie die Sätze knapp und wirkungsvoll. Vermeiden Sie Fachjargon.`
    },
    {
      title: "Präsentationsrede",
      content: `Schreiben Sie eine Rede für eine professionelle Präsentation oder Keynote.
- Der Anlass ist [eine Betriebsversammlung zum Start eines neuen Quartals].
- Der Redner ist [ein Teamleiter, der sich an ein gemischtes Publikum aus Ingenieuren, Designern und Managern wendet].
- Kernbotschaft: [die Erfolge des letzten Quartals feiern, Herausforderungen ehrlich anerkennen und das Team auf einen klaren Fokus für die kommenden Monate einschwören].
- Ton: [selbstbewusst, authentisch und motivierend — kein leeres Unternehmenssprech].
- Ungefähre Redezeit: [4 Minuten].
- Verwenden Sie gesprächige Formulierungen, strategische Pausen und einen einprägsamen Schlusssatz.`
    }
  ]
};
